export default  {"src":"/_next/static/image/public/assets/icons/tick.76182a7922322276e792d3246f85e617.svg","height":12,"width":16};